import { useState } from 'react';
import {
  IconButton,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from '@mui/material';

import { FurCoatCategory, ListResponse } from '@/types';
import { Pagination } from '@/components';
import { EditFlat, TrashFlat } from '@/assets/icons';
import theme from '@/theme';

import { DeleteFurCoatCategory, UpdateFurCoatCategory } from '.';

export interface FurCoatCategoryListProps {
  list?: ListResponse<FurCoatCategory>;
  page: number;
  onChangePage(page: number): void;
}

const FurCoatCategoriesTable: React.FC<FurCoatCategoryListProps> = ({ list, page, onChangePage }) => {
  const [updateModalOpened, setOpenedUpdateModal] = useState(false);
  const [deleteModalOpened, setOpenedDeleteModal] = useState(false);
  const [currentFurCoatCategory, setCurrentFurCoatCategory] = useState<FurCoatCategory | null>(null);

  function openUpdateModal(furCoatCategory: FurCoatCategory) {
    setCurrentFurCoatCategory(furCoatCategory);
    setOpenedUpdateModal(true);
  }

  function openDeleteModal(furCoatCategory: FurCoatCategory) {
    setCurrentFurCoatCategory(furCoatCategory);
    setOpenedDeleteModal(true);
  }

  return (
    <>
      <Stack spacing={3}>
        <TableContainer component={Paper} sx={{ maxHeight: `calc(100vh - ${theme.spacing(34.5)})` }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell>Наименование</TableCell>
                <TableCell>Цена</TableCell>
                <TableCell />
              </TableRow>
            </TableHead>

            <TableBody>
              {list?.data.map((furCoatCategory) => {
                const { name, price, id } = furCoatCategory;

                return (
                  <TableRow key={id}>
                    <TableCell>{name}</TableCell>
                    <TableCell>{price}</TableCell>

                    <TableCell>
                      <Stack direction="row" spacing={1}>
                        <Tooltip title="Обновить">
                          <IconButton aria-label="Обновить" onClick={() => openUpdateModal(furCoatCategory)}>
                            <EditFlat sx={{ fontSize: 16 }} />
                          </IconButton>
                        </Tooltip>

                        <Tooltip title="Удалить">
                          <IconButton aria-label="Удалить" onClick={() => openDeleteModal(furCoatCategory)}>
                            <TrashFlat sx={{ fontSize: 16 }} />
                          </IconButton>
                        </Tooltip>
                      </Stack>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>

        <Pagination
          size="medium"
          count={list?.meta.last_page}
          page={page}
          boundaryCount={2}
          color="primary"
          shape="rounded"
          onChange={(event, value) => onChangePage(value)}
        />
      </Stack>

      <UpdateFurCoatCategory
        furCoatCategory={currentFurCoatCategory!}
        open={updateModalOpened}
        onClose={() => setOpenedUpdateModal(false)}
      />
      <DeleteFurCoatCategory
        furCoatCategory={currentFurCoatCategory!}
        open={deleteModalOpened}
        onClose={() => setOpenedDeleteModal(false)}
      />
    </>
  );
};

export default FurCoatCategoriesTable;
